import { UPDATE_SPOT_SCREENSHOT } from "./screenshotImageSpotReducer"

export const updateSpotScreenshot = (image) => ({
    type: UPDATE_SPOT_SCREENSHOT,
    payload: image
})